import * as Sentry from '@sentry/browser';
import './polyfills';
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import 'lazysizes';
import * as serviceWorker from './serviceWorker';
import { createStore } from './landingpage/store';
import App from './landingpage/App';
import MainCtaButtonApp from './landingpage/apps/CoffeeLanding/MainCta/MainCta';
import RotationsApp from './landingpage/apps/CoffeeLanding/Rotations/Rotations';
import PricingApp from './landingpage/apps/CoffeeLanding/Pricing/Pricing';
import PricingFAQApp from './landingpage/apps/CoffeeLanding/PricingFAQ/PricingFAQ';
import MyAccountApp from './landingpage/apps/MyAccount/MyAccount';

if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({ dsn: process.env.REACT_APP_SENTRY_DSN });
}

if (process.env.REACT_APP_HOTJAR_ID) {
  import(/* webpackChunkName: 'react-hotjar' */ 'react-hotjar')
    .then(({ hotjar }) => {
      hotjar.initialize(process.env.REACT_APP_HOTJAR_ID, 6);
    })
    .catch(error => {
      Sentry.captureException(error);
    });
}

const { store, persistor } = createStore();

ReactDOM.render(
  <Suspense fallback="">
    <App store={store} persistor={persistor}>
      <MainCtaButtonApp position="heading" />
    </App>
  </Suspense>,
  document.querySelector('.main-cta')
);

ReactDOM.render(
  <Suspense fallback="">
    <App store={store} persistor={persistor}>
      <RotationsApp />
    </App>
  </Suspense>,
  document.querySelector('.pre-built-rotations')
);

ReactDOM.render(
  <Suspense fallback="">
    <App store={store} persistor={persistor}>
      <PricingApp />
    </App>
  </Suspense>,
  document.querySelector('.card-pricing')
);

ReactDOM.render(
  <Suspense fallback="">
    <App store={store} persistor={persistor}>
      <PricingFAQApp />
    </App>
  </Suspense>,
  document.querySelector('.faq-pricing-answer')
);

ReactDOM.render(
  <Suspense fallback="">
    <App store={store} persistor={persistor}>
      <MyAccountApp />
    </App>
  </Suspense>,
  document.querySelector('.my-account')
);

serviceWorker.unregister();
